
import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/fun-ui/Dialog";
import { UserAuthForm } from "../user-auth-form";


type BindMobileDialogProps = React.PropsWithChildren<{
  open: boolean;
  onOpenChange: (open: boolean) => void;
}>
export default function BindMobileDialog({
  open = false,
  onOpenChange,
}: BindMobileDialogProps) {

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="md:px-[6.25rem] pt-8 pb-16 w-screen md:w-fit min-w-fit max-w-fit ">
        <DialogHeader>
          <DialogTitle className="text-[2.5rem] leading-loose text-center w-full">绑定手机</DialogTitle>
        </DialogHeader>
        <UserAuthForm
          isBindMobile
          className="w-max md:w-[23.75rem]"
          label="提交"
        />
      </DialogContent>
    </Dialog>
  );
};